const normalizeGroupId = (groupId) =>
  groupId === null || groupId === undefined ? null : String(groupId);

const hasMedicalParameter = (item) =>
  item?.medicalParameters?.id !== null &&
  item?.medicalParameters?.id !== undefined;

// Los parámetros agregados por edad/sexo llegan sin `id`; la fila se identifica
// por grupo + parámetro, combinación que el API no repite.
export const isSameMedicalParameterRow = (item, row) =>
  hasMedicalParameter(item) &&
  normalizeGroupId(item?.medicalParameterGroupId) ===
    normalizeGroupId(row?.medicalParameterGroupId) &&
  String(item.medicalParameters.id) === String(row?.medicalParameters?.id);

export const getVisibleParameterGroups = (parameters = [], groups = []) => {
  const parameterGroupIds = new Set(
    parameters
      .filter(hasMedicalParameter)
      .map((item) => normalizeGroupId(item?.medicalParameterGroupId))
      .filter(Boolean),
  );
  const includedGroupIds = new Set();

  return groups.filter((group) => {
    const groupId = normalizeGroupId(group?.medicalParameterGroupId);
    if (
      !groupId ||
      !parameterGroupIds.has(groupId) ||
      includedGroupIds.has(groupId)
    ) {
      return false;
    }

    includedGroupIds.add(groupId);
    return true;
  });
};

export const getVisibleMedicalParameters = (parameters = [], groups = []) => {
  const visibleGroupIds = new Set(
    getVisibleParameterGroups(parameters, groups).map((group) =>
      normalizeGroupId(group?.medicalParameterGroupId),
    ),
  );

  return parameters.filter(
    (item) =>
      hasMedicalParameter(item) &&
      visibleGroupIds.has(normalizeGroupId(item?.medicalParameterGroupId)),
  );
};

export const getParameterGroupKey = (parameters = []) =>
  Array.from(
    new Set(
      parameters
        .filter(hasMedicalParameter)
        .map((item) => normalizeGroupId(item?.medicalParameterGroupId))
        .filter(Boolean),
    ),
  ).join("|");

export const isMedicalParameterRequired = (
  parameter,
  consultoryParameterGroups = [],
) => {
  if (typeof parameter?.required === "boolean") return parameter.required;

  const groupId = normalizeGroupId(parameter?.medicalParameterGroupId);
  const parameterId = parameter?.medicalParameters?.id;
  if (!groupId || parameterId === null || parameterId === undefined)
    return false;

  return consultoryParameterGroups.some(
    (group) =>
      normalizeGroupId(group?.medicalParameterGroupId) === groupId &&
      group?.consultoryParametersDetail?.some(
        (detail) =>
          String(
            detail?.medicalParametersId ?? detail?.medicalParameters?.id,
          ) === String(parameterId) && detail?.required === true,
      ),
  );
};

export const hasMedicalParameterValue = (parameter) => {
  const value = parameter?.medicalParameterValue;
  if (value === null || value === undefined) return false;

  return typeof value !== "string" || value.trim() !== "";
};
